import React from 'react';
import './ComoFunciona.css';

const pasos = [
  { n: 1, t: 'Elegí tu obra', d: 'Explorá por categorías, Shop o Servicios.' },
  { n: 2, t: 'Seleccioná tamaño', d: 'Distintas opciones de impresiones: 30×45, 50×70.' },
  { n: 3, t: 'Revisión y aprobación', d: 'Confirmamos compra y empezamos la producción.' },
  { n: 4, t: 'Impresión y envío', d: 'Embalaje seguro y envío a todo el país.' },
];

export default function ComoFunciona(){
  return (
    <section className="cf-wrap">
      <div className="cf-container">
        <div className="books-pasos">
          <h2 className="home-subtitle">¿Cómo funciona?</h2>
          <div className="pasos-grid">
            {pasos.map(p => (
              <div className="paso" key={p.n}>
                <span className="paso-num">{p.n}</span>
                <h3>{p.t}</h3>
                <p>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
